import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class LazadaProvider extends HttpRequest {
  getCategoryList (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/products/category-tree', query)
  }

  getAttributeList (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/products/category-attributes', query)
  }

  getRecommendCategoryList (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/products/category-suggestion', query)
  }

  getProductList (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/products', query)
  }

  getProductDetail (id, query) {
    this.setHeader(getAuthToken())
    return this.get(`/lazada/products/${id}`, query)
  }

  getDeliveryOptionList (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/products/warehouse-delivery-option/list', query)
  }

  getBrandList (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/products/brand/list', query)
  }

  getWarehouseList (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/products/warehouse/list', query)
  }

  getAuthorizedShop (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/authorized-shops', query)
  }

  deleteProduct (id, query) {
    this.setHeader(getAuthToken())
    return this.delete(`/lazada/products/${id}?brand=${query.brand}`)
  }

  createProduct (data) {
    this.setHeader(getAuthToken())
    return this.post(`/lazada/products?brand=${data.brand}`, data)
  }

  updateProduct (data) {
    this.setHeader(getAuthToken())
    return this.patch(`/lazada/products?brand=${data.brand}`, data)
  }

  syncProductStock (id, query) {
    this.setHeader(getAuthToken())
    return this.put(`/lazada/products/${id}/stock/update?brand=${query.brand}`)
  }

  syncAllStock (query) {
    this.setHeader(getAuthToken())
    return this.post(`/lazada/products/stock/sync-all?brand=${query.brand}`)
  }

  getWebhookLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada/webhook-logs', query)
  }

  getRequestLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada-request-logs', query)
  }

  getTokenLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/lazada-token-logs', query)
  }

  refreshToken (id) {
    this.setHeader(getAuthToken())
    return this.post(`/lazada-token-logs/refresh/${id}`)
  }

  connectShop (data) {
    this.setHeader(getAuthToken())
    return this.post('/public/lazada/connect-store', data)
  }
}
